module.exports = __webpack_public_path__ + "img/info_btn.1b91909e.png";